import { Engine } from '../../core/engine/Engine.type'
import onWindowEvent from '../../onWindowEvent'
import { getEngineKeyDownReactiveMap } from '../../three/fn/getSetEngineKeyDownReactiveMap'

export default function registerKeyDownEvent(engine: Engine) {
  const keyDownReactiveMap = getEngineKeyDownReactiveMap(engine)
  function onKeyDown(event: KeyboardEvent) {
    // console.log('onKeyDown', event)
    keyDownReactiveMap.set(event.key, event)
  }

  onWindowEvent('keydown', onKeyDown)
}
